
const namespaced = true;

const state = {
  sites: [],
  tags: [],
  currentClient: null,
};

const mutations = {
  SET_SITES(state, sites) {
    state.sites = sites;
  },
  SET_TAGS(state, tags) {
    state.tags = tags;
  },
  SET_CURRENT_CLIENT(state, client) {
    state.currentClient = client;
  },
};

const actions = {
  setCurrentClient({ commit }, client) {
    commit(`SET_CURRENT_CLIENT`, client);
  },
  async fetchList({ commit, dispatch }) {
    const clientId = state.currentClient.id;
    const sites = await dispatch(`model/site/fetchSitesForClientWithClientTags`, clientId, { root: true });

    commit(`SET_SITES`, sites);
    return sites;
  },
  async fetchTags({ commit, dispatch }) {
    commit(`SET_TAGS`, []);
    const clientId = state.currentClient.id;
    const tags = await dispatch(`model/tag/fetchForClient`, clientId, { root: true });

    commit(`SET_TAGS`, tags);
    return tags;
  },
};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
